import React from 'react'
import {
  CircularProgress,
  ClickAwayListener,
  Popper,
  Checkbox,
  useTheme
} from '@mui/material'
import { ArrowDown2 } from 'iconsax-react'

import useKeyListener from '@SonarCX/hooks/useKeyListener'
import useStyles from './styles'

const LIMIT = 15
const MultiDropdown = ({
  options = [],
  renderOption = val => val,
  selected,
  onSelect,
  hideClose = false,
  children,
  disabled = false,
  forceOpen = false,
  onOpen = () => { },
  onClose = () => { },
  disablePortal = false,
  closeOnScroll = false,
  loading = false,
  popperProps = {},
  ChildWrapper = React.Fragment,
  wrapperClass = ""
}) => {
  const [search, setSearch] = React.useState('')
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)
  const mainRef = React.useRef()
  const theme = useTheme()

  const classes = useStyles({ disabled })

  React.useEffect(() => {
    if (forceOpen && mainRef.current) {
      mainRef.current.click()
    }
  }, [forceOpen])

  const handleClick = e => {
    if (!disabled) {
      setAnchorEl(anchorEl ? null : e.currentTarget)
      onOpen && onOpen()
    }
  }

  const handleSearch = e => {
    const val = e.target.value
    setSearch(val)
  }

  const handleClose = React.useCallback(() => {
    setAnchorEl(old => {
      if (old) {
        onClose && onClose()
      }

      return null
    })
  }, [onClose])

  useKeyListener({ key: 'Escape', callback: handleClose })

  const handleSelect = (opt, e) => {
    onSelect(opt, e.target.checked)
  }
  // Auto close on scroll
  React.useEffect(() => {
    const onScroll = () => {
      handleClose()
    }

    if (closeOnScroll) {
      document.addEventListener('wheel', onScroll, { passive: true })
    }

    return () => {
      if (closeOnScroll) {
        document.removeEventListener('wheel', onScroll)
      }
    }
  }, [handleClose, closeOnScroll])

  let filtered = options
  const hideSearch = filtered.length < LIMIT

  filtered = options
    .map(renderOption)
    .filter(opt => opt?.toLowerCase().includes(search.toLowerCase()))
    .map(val => options.find(opt => val === renderOption(opt)))

  const renderOptions = () => {
    if (!filtered.length) {
      return <div>No Options</div>
    } else {
      return filtered.map(opt => (
        <div key={opt} style={{ display: 'flex', alignItems: 'center' }}>
          <Checkbox
            checked={selected.includes(opt)}
            onChange={e => handleSelect(opt, e)}
            className={classes.checkBox}
          />
          {renderOption(opt)}
        </div>
      ))
    }
  }
  return (
    <ClickAwayListener onClickAway={handleClose}>
      <div className={wrapperClass}>
        <div ref={mainRef} onClick={handleClick} className={classes.children}>
          {open ? children : <ChildWrapper>{children}</ChildWrapper>}
        </div>

        <Popper
          open={open}
          anchorEl={anchorEl}
          style={{ zIndex: '1500' }}
          disablePortal={disablePortal}
          modifiers={[
            { name: 'flip' },
            { name: 'offset', options: { offset: [15, 0] } }
          ]}
          {...popperProps}
        >
          <div className={classes.menu}>
            {hideSearch ? null : (
              <div className={classes.search}>
                {hideSearch ? (
                  <div />
                ) : (
                  <input
                    placeholder='Search...'
                    value={search}
                    onChange={handleSearch}
                    className={classes.input}
                  />
                )}

                {hideClose ? (
                  <div />
                ) : (
                  <ArrowDown2
                    variant='Bold'
                    size={theme.size.base}
                    onClick={handleClose}
                    className={classes.close}
                  />
                )}
              </div>
            )}

            {loading ? (
              <div className={classes.loading}>
                <CircularProgress />
              </div>
            ) : (
              renderOptions()
            )}
          </div>
        </Popper>
      </div>
    </ClickAwayListener>
  )
}

export default MultiDropdown
